import { PuzzleFormat } from './puzzleFormat'

export const RECENT = 'recent'
export const FAVORITE = 'favorite'
export const PLAY_TOGETHER = 'playTogether'

export type PuzzleFilter2 = typeof FAVORITE | PuzzleFormat | string | typeof RECENT | typeof PLAY_TOGETHER
